import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import FaChevronLeft from 'react-icons/lib/fa/chevron-left';

import {
    Button,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import styles from './FilterMenu.scss';

function FilterMenu(props) {
    const {
        t,
        totalTrips,
        showReset,
        onCloseMenu,
        onReset,
        children,
    } = props;

    function _onClick() {
        if (totalTrips > 0) {
            return onCloseMenu();
        }
        return onReset();
    }

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <span
                    className={styles.closeButtonContainer}
                    onClick={onCloseMenu}
                    role="button"
                >
                    <FaChevronLeft className={styles.closeButton} />
                </span>
                <span className={styles.filterText}>
                    {t('filters')}
                </span>
                {showReset && (
                    <span
                        className={styles.resetButton}
                        onClick={onReset}
                        role="button"
                    >
                        {t('reset')}
                    </span>
                )}
            </div>
            {children}
            <div className={styles.footer}>
                <Button
                    className={classNames(
                        styles.selectButton,
                        { [styles.inactive]: totalTrips === 0 },
                    )}
                    onClick={_onClick}
                >
                    {totalTrips > 0
                        ? t('num-search-results', {
                            numTrips: totalTrips,
                        })
                        : `${t('num-trips', { numTrips: totalTrips })} | ${t('reset-filters')}`}
                </Button>
            </div>
        </div>
    );
}

FilterMenu.propTypes = {
    totalTrips: PropTypes.number,
    showReset: PropTypes.bool,
    onCloseMenu: PropTypes.func,
    onReset: PropTypes.func,
};

FilterMenu.defaultProps = {
    totalTrips: 0,
    showReset: false,
    onCloseMenu() {},
    onReset() {},
};

export { FilterMenu };
export default localize(FilterMenu, 'baseApp');
